import React from "react";
import { Link } from "react-router-dom";
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from "@ant-design/icons";
import "../home.css";
import "../styles/home-journey.css";
import "../styles/contact.css";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { WhatsAppWidget } from "../components/WhatsAppWidget";
import { ContactForm } from "../components/ContactForm";

export const ContactPage = () => (
    <div className="container journey-page contact-page">
        <Header />
        <div className="content contact-page__content">
            <div className="home-container contact-page__main">
                <header className="contact-page__intro">
                    <p className="home-eyebrow">Get in Touch</p>
                    <h1 className="contact-page__title">Let's grow your business together</h1>
                    <p className="contact-page__subtitle">
                        Share your goals and we'll recommend the right solutions and software for your journey.
                    </p>
                </header>

                <div className="contact-page__grid">
                    <div className="contact-page__form-col">
                        <ContactForm />
                    </div>
                    <aside className="contact-page__info">
                        <div className="contact-page__info-content">
                            <h2>Contact Information</h2>
                            <div className="contact-page__info-item">
                                <PhoneOutlined className="contact-page__info-icon" />
                                <div>
                                    <strong>Phone</strong>
                                    <a href="tel:8838887194">+91 8838887194</a>
                                </div>
                            </div>
                            <div className="contact-page__info-item">
                                <MailOutlined className="contact-page__info-icon" />
                                <div>
                                    <strong>Email</strong>
                                    <a href="mailto:support@honesti.in">support@honesti.in</a>
                                </div>
                            </div>
                            <div className="contact-page__info-item">
                                <EnvironmentOutlined className="contact-page__info-icon" />
                                <div>
                                    <strong>Address</strong>
                                    <span>No 26, Aadilakshmi Nagar, Lakshmipuram, Kolathur, Chennai- 99</span>
                                </div>
                            </div>
                        </div>
                        <div className="contact-page__info-footer">
                            <a
                                href="https://wa.me/+918838887194"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contact-page__whatsapp-btn"
                            >
                                Chat on WhatsApp
                            </a>
                            <p className="contact-page__home-link">
                                <Link to="/">← Back to Home</Link>
                            </p>
                        </div>
                    </aside>
                </div>
            </div>

            <div className="wrapper contact-page__footer-wrap">
                <Footer />
            </div>
        </div>
        <WhatsAppWidget />
    </div>
);
